import React, { useEffect } from 'react';
import { Modal, Form, DatePicker, InputNumber, Select, Input, message } from 'antd';
import dayjs from 'dayjs';
import { useFinanceApi, DOVIZ_OPTIONS, entityOptions } from '../api/financeApi';
import { inputNumberMoneyProps } from '../../../utils/currency';

/**
 * Converts an "Ödeme Talebi" record into a real payment.
 * POST /finance/payment-requests/{id}/process -> INSERT nf_odemeler + DELETE talebi.
 */
export default function PaymentProcessModal({ row, lookups, onClose, onDone }) {
  const api = useFinanceApi();
  const [form] = Form.useForm();

  useEffect(() => {
    if (row) {
      form.setFieldsValue({
        tarih: dayjs(),
        tutar: row.tutar,
        doviz: row.doviz || 'TRY',
        islem_turu_id: row.islem_turu_id,
        banka_hesap_id: undefined,
        aciklama: row.aciklama,
      });
    }
  }, [row, form]);

  const submit = async () => {
    let v;
    try { v = await form.validateFields(); } catch { return; }
    try {
      await api.post(`/payment-requests/${row.id}/process`, {
        tarih: dayjs(v.tarih).format('YYYY-MM-DD'),
        tutar: v.tutar,
        doviz: v.doviz,
        cari_id: row.cari_id,
        firma_id: row.firma_id,
        islem_turu_id: v.islem_turu_id,
        banka_hesap_id: v.banka_hesap_id,
        aciklama: v.aciklama,
      });
      message.success('Ödeme oluşturuldu');
      onDone();
    } catch (e) {
      message.error(e?.response?.data?.detail || 'İşlem başarısız');
    }
  };

  return (
    <Modal
      title="Ödeme Talebini Öde"
      open={!!row}
      onOk={submit}
      onCancel={onClose}
      okText="Öde"
      cancelText="Vazgeç"
      destroyOnClose
    >
      <Form form={form} layout="vertical">
        <Form.Item name="tarih" label="Ödeme Tarihi" rules={[{ required: true }]}>
          <DatePicker style={{ width: '100%' }} format="DD.MM.YYYY" />
        </Form.Item>
        <Form.Item name="tutar" label="Tutar" rules={[{ required: true }]}>
          <InputNumber {...inputNumberMoneyProps} style={{ width: '100%' }} step={0.01} />
        </Form.Item>
        <Form.Item name="doviz" label="Döviz">
          <Select options={DOVIZ_OPTIONS} />
        </Form.Item>
        <Form.Item name="islem_turu_id" label="İşlem Türü (Ödeme)" rules={[{ required: true }]}>
          <Select showSearch optionFilterProp="label"
            options={entityOptions(lookups, 'islem_turu', (i) => Number(i.odeme) === 1)} />
        </Form.Item>
        <Form.Item name="banka_hesap_id" label="Banka Hesabı" rules={[{ required: true }]}>
          <Select showSearch optionFilterProp="label" options={entityOptions(lookups, 'hesaplar')} />
        </Form.Item>
        <Form.Item name="aciklama" label="Açıklama">
          <Input.TextArea rows={2} />
        </Form.Item>
      </Form>
    </Modal>
  );
}
